import React, { FunctionComponent, useState } from "react"
import { useMutation } from "@apollo/client"
import { Icon, Alert } from "@kuali/pure-ui"

import Provider from "../../utils/connected-apollo-provider"
import { UPDATE_ACTION_ITEM } from "./queries"

import DeleteToast from "./delete-toast"

interface Props {
  actionItemId: number
}

const ActionItems: FunctionComponent<Props> = ({ actionItemId }) => {
  const [deleteSuccessCallback, setDeleteSuccessCallback] = useState(null)
  const [isUndeleted, setUndeleted] = useState(null)
  const [isUnsuccesful, setIsUnsuccesful] = useState(false)

  // mutation to update plan status
  const [updateActionItem, { data }] = useMutation<{
    updateActionItem
  }>(UPDATE_ACTION_ITEM, {
    onCompleted({ updateActionItem }) {
      if (updateActionItem && updateActionItem.actionItem) {
        // clear out any potential error message
        setIsUnsuccesful(false)

        // if there is a callback to fire when deletion is complete
        if (deleteSuccessCallback) {
          // show successfull archive message, if in progress of unarchiving
          // update message
          const deleteMessage = updateActionItem.actionItem.archived
            ? "Item successfully archived"
            : "Undeleting in progress.."

          deleteSuccessCallback(deleteMessage)

          // TODO - for now reload after success,
          // will be handled in cache update in next PR
          if (window) {
            window.setTimeout(() => {
              window.location.reload()
            }, 5000)
          }
        }

        // if item has been unarchived, update state to indicate action item has been unarchived
        if (!updateActionItem.actionItem.archived && !deleteSuccessCallback) {
          // update state to indicate undelete is successful
          setUndeleted(true)
        }
      }
    },
    onError(error) {
      setIsUnsuccesful(true)
    }
  })

  const handleDeleteActionItem = (showToastCallback: any) => {
    // set action callback to be used in success handler
    setDeleteSuccessCallback(() => {
      return showToastCallback
    })

    // make request to update action item and set to archived
    updateActionItem({
      variables: {
        id: actionItemId,
        archived: true
      }
    })
  }
  const handleUndoAction: any = (showToastCallback: any) => {
    // clear success callback as delete has been undone
    setDeleteSuccessCallback(null)

    // make request to unarchive action item
    updateActionItem({
      variables: {
        id: actionItemId,
        archived: false
      }
    })
  }
  return (
    <React.Fragment>
      <DeleteToast
        onDeleteActionItem={handleDeleteActionItem}
        onUndoAction={handleUndoAction}
      ></DeleteToast>
      {/* Handle both success and error message in same alert */}
      <Alert
        id={"alert"}
        color={isUnsuccesful ? "red" : "green"}
        icon={<Icon name={isUnsuccesful ? "alert-error" : "alert-info"} />}
        message={
          isUnsuccesful
            ? "Error deleting action item"
            : "Action item deletion successfully cancelled."
        }
        primaryButtonLabel={"Ok"}
        closeButtonLabel={"Close"}
        isOpen={(data && isUndeleted) || isUnsuccesful}
        onPrimaryButtonClicked={() => {
          setUndeleted(false)
          setIsUnsuccesful(false)
        }}
        onCloseButtonClicked={() => {
          setUndeleted(false)
          setIsUnsuccesful(false)
        }}
      />
    </React.Fragment>
  )
}

const ActionItemWithApollo = (props) => {
  // wrap Action Item in Provider HOC to connect to Apollo -
  // would otherwise be passed in via routing on full page, will be done on full move to React
  return (
    <Provider>
      <ActionItems {...props} />
    </Provider>
  )
}

export default ActionItemWithApollo
